import { render } from "./ABTestingDashboard.vue?vue&type=template&id=2e12327c&scoped=true"
import script from "./ABTestingDashboard.vue?vue&type=script&lang=js"
export * from "./ABTestingDashboard.vue?vue&type=script&lang=js"

import "./ABTestingDashboard.vue?vue&type=style&index=0&id=2e12327c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e12327c"]])

export default __exports__